module.exports = __webpack_public_path__ + "assets/img/ic-ncoindetail.d57d8875.svg";